import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热搜榜单</h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">实时更新的吃瓜视频热度排行榜，看看大家都在看什么</p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`flex items-center gap-4 px-5 py-4 hover:bg-primary-50/30 transition-colors group ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-400 text-background-50' :
                item.rank === 3 ? 'bg-primary-300 text-background-50' :
                'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">{item.title}</p>
              </div>

              <div className="flex items-center gap-3 shrink-0">
                <span className="text-xs text-foreground-500">{item.views} 次观看</span>
                <span className={`w-5 h-5 flex items-center justify-center ${
                  item.trend === 'up' ? 'text-accent-500' :
                  item.trend === 'hot' ? 'text-primary-500' :
                  item.trend === 'down' ? 'text-foreground-400' :
                  'text-foreground-400'
                }`}>
                  {item.trend === 'down' ? (
                    <i className="ri-arrow-down-line text-sm"></i>
                  ) : (
                    <i className="ri-arrow-up-line text-sm"></i>
                  )}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}